module.exports = __webpack_public_path__ + "static/media/ev-page-screenshot.6735f5cd.png";